@use "~theme/breakpoints";
.container {
    max-width: 100%;
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px #eaeaea;
    border-radius: 4px;
    float: right;
    margin-top: 5px;
}
.mobilecontainer {
    border-bottom: 1px solid #E6EBF0;
    @include breakpoints.desktop {
        display: none;
      }
    .noBackground {
        background: none;
    }
}
.moveTop {
    top: 5%;
}

.headerSection {
    border: 0.5px solid #D5D5D5;
    height:35px;
    text-transform: uppercase;
    padding-top: 5px;
}

.heading {
    float: left;
    width:85%;
    padding: 1px 0px 0px 10px;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #003366;
    @include breakpoints.desktop {
        width: 100%;
        font-size: 12px;
    }
    @include breakpoints.desktop-medium {
        font-size: 14px;
    }
    @include breakpoints.desktop-large {
        font-size: 16px; 
    }
}

.loading {
    @include breakpoints.desktop {
        width: 80%;
    }
}

.action {
    color: #003366;
    float:right;
    width:20%;
    padding: 1px 10px 0px 0px;
    text-align: right;
    text-decoration: underline;
}

.contentSection {
    box-shadow: 0px 2px 6px #eaeaea;
    background-color: var(--white);
    padding: 10px 0px;
    @include breakpoints.desktop {
        display: block;
        overflow: auto;
        padding:0px;
    }
}

.contentLeft {
    float:left;
    width: 55%;
    padding-left: 10px;
    padding-top: 10px;
}

.contentRight {
    float:right;
    width:45%;
    text-align: right;
    padding-right: 10px;
    padding-top: 10px;
}

.contentLeftNoAvail {
    align-items: center;
    padding: 16px 10px;
    text-align: center;
    @include breakpoints.desktop {
        float:left;
        width: 20%;
        display: flex;        
    }
}

.contentRightNoAvail {
    color: var(--black);
    padding: 0px 10px;
    width:100%;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    letter-spacing: 0.02em;
    text-align: center;
    @include breakpoints.desktop {
        float:right;
        width: 80%;        
        color: rgba(35, 31, 32, 0.75);
        padding: 10px;        
    }
    span {
        text-decoration: underline;
        color: var(--blue-01);
        cursor: pointer;
    }
}

.footerPhoneLink {
    white-space: nowrap;
}

.officeName {
    font-size: 16px;
    color: black;
    font-weight: 600;
    text-decoration-line: underline;
}

.officeAddress {
    color: rgba(0, 0, 0, 0.7);
    font-size: 13px;
    font-weight: 400;
    @include breakpoints.desktop {
        font-size: 14px;
    }
}

.officePhone {
    color: #003366;
    font-size: 12px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.02em;
}

.icon {
    margin-right: 5px;
    width: 16px;
    @include breakpoints.desktop {
        width: auto;
    }
}

.medicaid {
    color: #003366;
    font-size: 10px;
    font-weight: 400;
}

.timings {
    color: #003366;    
    font-size: 14px;
    font-weight: 600;
    line-height: 140%;
    letter-spacing: 0.02em;
    @include breakpoints.desktop {
        font-size: 12px;
        font-weight: 400;
    }
}

.nearbyContent {
    cursor: pointer;
    display: block;
    overflow: auto;
    box-shadow: 0px 2px 6px #eaeaea;
    margin: 7px 13px;
    padding-bottom: 7px;
    @include breakpoints.desktop {
        padding-bottom: 0px;
        margin: 0px;
        box-shadow: none;
    }
}

.closedContent {
    padding-bottom: 0px;
    margin: 0px;
    box-shadow: none;
}

.noAvailSpan {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #003366;
    @include breakpoints.desktop {
        margin-left: 10px;
    }
}

.contentHeader {
    background: #6FC7ED;
    border-radius: 4px 4px 0px 0px;
    height: 34px;
    align-items: center;
    display: flex;
    text-align: center;
    img {
        right: 6%;
        padding: 8px;
        @include breakpoints.desktop {
            padding: 8px;
        }
    }
    .miles {
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 140%;
        align-items: center;
        letter-spacing: 0.02em;
        text-transform: lowercase;
        color: var(--blue-01);
        width: 30%;
        float: left;
        text-align: left;
    }
    .examDetails {
        font-weight: 700;
        font-size: 13px;
        line-height: 15px;
        display: block;
        align-items: center;
        text-align: right;
        color: var(--blue-01);
        width: 70%;
        letter-spacing: -0.02em;
        margin-right: 10px;
        @include breakpoints.desktop {
            font-weight: 500;
        }
    }
}
.spinner {
    margin: 0 10px 4px 0;
}